"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const images_1 = require("../../services/images");
const DurationInputWeb = ({ duration, setDuration }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'search' });
    const handleChange = (event) => {
        const inputValue = event.target.value;
        setDuration(`${inputValue}:00`);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "box", children: [(0, jsx_runtime_1.jsx)("img", { alt: "", src: images_1.icons.Duration, className: "icon" }), (0, jsx_runtime_1.jsx)("p", { className: "duration-label", children: t('duration') }), (0, jsx_runtime_1.jsx)("input", { type: "time", onChange: handleChange, value: duration || "00:00" })] }));
};
exports.default = DurationInputWeb;
